/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Operator } from './workflow-operator';

export class WorkflowNodeData {
    id: number;
    property: string;
    operator: Operator;
    value: string;
}
    
